// extracted by mini-css-extract-plugin
export var statItem = "_kq-1";
export var statsRow = "_kq-0";